var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "link-el" },
    [
      _c("img", {
        staticClass: "link__img",
        attrs: {
          src: require("../../assets/icons/i_arrow-red.svg"),
          alt: "arrow",
        },
      }),
      _vm._v(" "),
      _c("nuxt-link", { staticClass: "link__link", attrs: { to: _vm.link } }, [
        _vm._v(_vm._s(_vm.text)),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }